import { ObstetricalFileContributionType } from "@/Patient/Models/ObstetricalFile/Enum/ObstetricalFileContributionType";
import { ObstetricalFileType } from "@/Patient/Models/ObstetricalFile/Enum/ObstetricalFileType";
import { BritishColumbiaObstetricalFileForm } from "./BritishColumbia/BritishColumbiaObstetricalFileForm";
import { OntarioObstetricalFileForm } from "./Ontario/OntarioObstetricalFileForm";
import { QuebecObstetricalFileForm } from "./Quebec/QuebecObstetricalFileForm";
import { BaseObstetricalFileForm, ObstetricFormContext } from "./BaseObstetricalFileForm";

class BaseObstetricalFileModel {
    public Id: string;
    public ContributionId: string;
    public EncounterId: string;
    public PatientContactFacetId: string;
    public ObstetricalFileType: ObstetricalFileType;
    public Form: string;
    public PostnatalDate: Date;
    public ContributionType: ObstetricalFileContributionType;

    constructor(fields?: Partial<BaseObstetricalFileModel>) {
        Object.assign(this, fields);
    }

    /**
     * Get a parsed representation of the form data.
     * @template TForm The expected form. This only sets the return type, it has no effect on parsing.
     */
    public getFormObject<TForm extends BaseObstetricalFileForm>(): TForm {
        if (!this.Form)
            return null;

        let value = JSON.parse(this.Form) as BaseObstetricalFileForm;
        value.Context = new ObstetricFormContext({
            ContributionId: this.ContributionId,
            EncounterId: this.EncounterId,
            PatientContactFacetId: this.PatientContactFacetId
        });

        switch (this.ObstetricalFileType) {
            case ObstetricalFileType.QuebecForm:
                value = new QuebecObstetricalFileForm(value);
                break;

            case ObstetricalFileType.OntarioForm:
                value = new OntarioObstetricalFileForm(value);
                break;

            case ObstetricalFileType.BritishColumbiaForm:
                value = new BritishColumbiaObstetricalFileForm(value);
                break;
        }

        return value as TForm;
    }
}

export { BaseObstetricalFileModel };
